// src/components/Jobs/JobCard.jsx
import React from 'react';
import { getExperienceLabel } from '../../utils/experienceLevels';

const JobCard = ({ job, onViewDetails }) => {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-ZA');
    };

    const getLocationDisplay = () => {
        if (job.city) {
            return `${job.city}, ${job.province}`;
        }
        return job.province || 'Location not specified';
    };

    return (
        <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer group">
            {/* Job Type Badges */}
            <div className="flex flex-wrap gap-2 mb-2">
                {job.isSponsored && (
                    <span className="text-xs bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full inline-flex items-center gap-1">
                        <i className="fas fa-star text-yellow-500"></i> Sponsored
                    </span>
                )}
                {job.jobType === 'internal' && (
                    <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full inline-flex items-center gap-1">
                        <i className="fas fa-check-circle"></i> Internal
                    </span>
                )}
                {job.jobType === 'external' && (
                    <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full inline-flex items-center gap-1">
                        <i className="fas fa-external-link-alt"></i> External
                    </span>
                )}
            </div>

            <h3 className="text-lg md:text-xl font-bold text-gradpath-green mb-2 line-clamp-2">{job.title}</h3>
            
            <div className="flex flex-wrap gap-3 text-sm text-gray-600 mb-3">
                <span className="inline-flex items-center gap-1">
                    <i className="fas fa-map-marker-alt text-gradpath-green"></i> {getLocationDisplay()}
                </span>
                <span className="inline-flex items-center gap-1">
                    <i className="fas fa-briefcase text-gradpath-green"></i> {job.workType}
                </span>
                <span className="inline-flex items-center gap-1">
                    <i className="fas fa-calendar-alt text-gradpath-green"></i> Closes: {formatDate(job.closingDate)}
                </span>
            </div>

            {/* Experience Level Badge */}
            {job.experienceLevel && (
                <div className="mb-3">
                    <span className="inline-flex items-center gap-1 text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-full">
                        <i className="fas fa-chart-line"></i>
                        {getExperienceLabel(job.experienceLevel)}
                    </span>
                </div>
            )}
            
            <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                {job.description?.substring(0, 120)}...
            </p>
            
            {job.salary && (
                <p className="text-sm text-gray-500 mb-3">
                    <i className="fas fa-money-bill-wave text-gradpath-green mr-1"></i> {job.salary}
                </p>
            )}
            
            <button 
                onClick={(e) => {
                    e.stopPropagation();
                    onViewDetails(job);
                }}
                className="w-full bg-gradpath-green text-white font-semibold py-2 px-4 rounded-lg hover:bg-gradpath-dark transition-all inline-flex items-center justify-center gap-2 group-hover:shadow-md"
            >
                <i className="fas fa-info-circle"></i> View Details
            </button>
        </div>
    );
};

export default JobCard;